import { z } from "zod";

export const notificationCaseSchema = z.object({
    id: z.number(),
    idUUID: z.string(),
    clientName: z.string(),
    caseStatus: z.string().nullable(),
    checkReceived: z.boolean().optional().nullable(),
    umCheckReceived: z.boolean().optional().nullable(),
});

export const notificationNoteSchema = z.object({
    idUUID: z.string(),
    tag: z.string(),
});

export const notificationSchema = z.object({
    idUUID: z.string(),
    hasUnreadNotification: z.boolean(),
    title: z.string().nullable(),
    priority: z.string().nullable(),
    notifiedUsers: z.string().nullable(),
    updated: z.string().nullable(),
});
